import { Box } from "@mui/material"
import { useEffect, useState } from "react"
import { Goddess, QuestionType } from "../types/types"
import Form from "./form"
import Result from "./result"

const FullForm = () => {

    const [questions, setQuestions] = useState<QuestionType[]>([])
    const [goddesses, setGoddesses] = useState<Goddess[]>([])
    const [result, setResult] = useState<Goddess|undefined>(undefined)
    
    useEffect(() => {
        fetch('/goddessInfo/questions.json')
        .then((response) => response.json())
        .then((data) => setQuestions(data))
        .catch((error) => console.error('Error fetching JSON:', error));
    }, [])

    useEffect(() => {
        fetch('/goddessInfo/goddesses.json')
        .then((response) => response.json())
        .then((data) => setGoddesses(data))
        .catch((error) => console.error('Error fetching JSON:', error));
    }, [])

    const onAnswerChange = (questionId: number, goddessCode: number) => {
        setQuestions((prev)=> {
            let q = prev.find(x => x.id === questionId)
            if (q){
                const updatedQuestion = { ...q, result: goddessCode}   
                const updt = prev.map(question => question.id === questionId ? updatedQuestion : question)
                return updt ?? prev
            }
            else{
                return prev
            }

        })
    }

    const getResult = () => {
        const responsesMap: { [key: number]: number } = {};

        for (const item of questions){
            if (item.result){
                responsesMap[item.result] = (responsesMap[item.result] || 0) + 1
            }
        }

        let mostFrequent: number | null = null;
        let maxFrequency = 0;

        for (const response in responsesMap) {
            if (responsesMap[response] > maxFrequency) {
                mostFrequent = Number(response);
                maxFrequency = responsesMap[response];
            }
        }

        setResult(goddesses.find(x => x.code === mostFrequent))
    }

    useEffect(() => console.log(questions), [questions])

    return(
        <Box>
            {  result ?
                <Box paddingX={{xs: 5, sm: 10}} paddingY={5}>
                    <Result result={result}/>
                </Box>
                : 
                <Form questions={questions} getResult={getResult} onAnswerChange={onAnswerChange}/>
            }
        </Box>
    )
}

export default FullForm